import React, { useState, useEffect } from "react";
import {Input, Form, Col, Row, Button, Select, Tooltip} from "antd";
import {PlusOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import {
  defaultValidateMessages,
  onInputMaxLengthCheck,
  onKeyDownNumberOnly,
} from "./Helper";
import TextArea from "antd/lib/input/TextArea";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const TosBankInfoAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [activeBankId, setActiveBankId] = useState();
  const [form] = Form.useForm();

  const [connectionType, setConnectionType] = useState("none");

  const [isSupportwebService, setIsSupportwebService] = useState(false);
  const [isSupportSftp, setIsSupportSftp] = useState(false);
  const [isSupportMail, setIsSupportMail] = useState(false);
  const [isSupportPdf, setIsSupportPdf] = useState(false);


  useEffect(() => {
    getNotAddedBanks();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getNotAddedBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });

    RequestHandler.get(`/Bank/GetTosBankDropdown`).then((response) => {
      setBankSelect({
        data: response.filter((x) => x.id !== 999),
        loading: false,
      });
    });
  };


  const onFinish = (values) => {
    setLoading(true);
    if(values.connectionType == "mail") {
      values.IsUseEmail = true;
    }

    if(values.connectionType === "webService") {
      values.IsUseWebService  = true;
    }

    if(values.connectionType == "pdf") {
      values.IsUsePdf = true;
    }

    delete values.connectionType;



    RequestHandler.post(`/TosBankInfo`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        getNotAddedBanks();
        form.resetFields();
        setConnectionType("none");
        if (props.onSuccess) props.onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onBankChange = (bankId) => {

    setActiveBankId(bankId);

    var bank = bankSelect.data.filter((x) => x.id === bankId)[0];

    setIsSupportSftp(bank.isTosSupport);
    setIsSupportwebService(bank.isOnlineTosSupport);
    setIsSupportMail(bank.isMailTosSupport);
    setIsSupportPdf(bank.isTosSupportPdf);

    setConnectionType("none");
    form.resetFields(["connectionType"]);
  };

  const onConnectionTypeChange = (type) => {

    if(type === "sftp") {
      RequestHandler.get(`/TosBankInfo/GetRequired/${activeBankId}`).then((response) => {
        if(response.data) {
          form.setFieldsValue({"port": response.data.serviceDefaultPort, "host": response.data.serviceDefaultHost});
        }
        else {
          form.resetFields(["port", "host"]);
        }
      });
    }

    setConnectionType(type);
  }

  const FormItemLabelWithTooltip = ({ label, tooltip }) => {
    return (
      <>
        {label}{" "}
        <Tooltip title={
          <span>
            {tooltip?.split('*').filter(part => part.trim() !== '').map((line, index) => (
              <div key={index}> * {line}</div>
            ))}
          </span>
        } overlayStyle={{ maxWidth: "450px" }}>
          <QuestionCircleOutlined
            className="gx-text-blue"
            style={{ marginLeft: 5,marginRight:3, fontSize: "120%" }}
          />
        </Tooltip>
      </>
    );
  };
  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="tosBankInfoAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="bankId" label="Banka" rules={[{ required: true }]}>
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              onChange={onBankChange}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={bankSelect.loading}
            >
              {bankSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

            <Form.Item name="connectionType" label="Bağlantı Tipi">
              <Select placeholder="Seçiniz" onChange={onConnectionTypeChange}>
                { isSupportSftp ? <Select.Option key="sftp" value="sftp">Sftp</Select.Option> : <></>  }
                { isSupportMail ? <Select.Option key="mail" value="mail">Mail</Select.Option> : <></> }
                { isSupportwebService ? <Select.Option key="webService" value="webService">Web Servis</Select.Option> : <></> }
                { isSupportPdf ? <Select.Option key="pdf" value="pdf">Pdf</Select.Option> : <></> }
              </Select>
            </Form.Item>


            { connectionType == "sftp" ?

              <>
                <Form.Item
                  label={
                    "Müşteri Numarası"
                  }
                  name="customerNumber"
                  rules={[{ required: true, whitespace: true }]}
                >
                  <Input maxLength="125" onInput={onInputMaxLengthCheck} />
                </Form.Item>

                  {
                    activeBankId === 15 ?
                    <Form.Item
                      label={
                        "Kurum Kodu"
                      }
                      name="corporateCode"
                      rules={[{ required: true, whitespace: true }]}
                    >
                      <Input maxLength="5" onInput={onInputMaxLengthCheck} />
                    </Form.Item>
                    :
                    null
                  }

                  <Form.Item style={{ marginBottom: 0 }} label="Host" required>
                    <Input.Group>
                      <Row gutter={2}>
                        <Col span={18}>
                            <Form.Item
                              name="host"
                              rules={[
                                {
                                  required: true,
                                  whitespace: true,
                                  message: "'Host' alanı gerekli.",
                                },
                              ]}
                            >
                              <Input />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                              name="port"
                              rules={[
                                {
                                  required: true,
                                  whitespace: true,
                                  message: "'Port' alanı gerekli.",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Port"
                                onKeyDown={(e) => onKeyDownNumberOnly(e)}
                                maxLength="5"
                                onInput={onInputMaxLengthCheck}
                              />
                            </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>

                  <Form.Item
                    label={
                      <FormItemLabelWithTooltip
                        label="Gelen Dosya Yolu"
                        tooltip="info@koletra.com mail adresine sorarak öğreniniz."
                      />

                    }
                    name="DownloadFolder"
                    rules={[{ required: true, whitespace: true }]}

                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label={

                      <FormItemLabelWithTooltip
                        label="Giden Dosya Yolu"
                        tooltip="info@koletra.com mail adresine sorarak öğreniniz."
                      />
                    }
                    name="UploadFolder"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={
                      "Kullanıcı Adı"
                    }
                    name="userName"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Şifre"
                    name="password"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input.Password autoComplete="new-password" />
                  </Form.Item>
              </> :
              connectionType == "mail" ?
              <>
                <Form.Item
                  label={
                    "Müşteri Numarası"
                  }
                  name="customerNumber"
                  rules={[{ required: true, whitespace: true }]}
                >
                  <Input maxLength="125" onInput={onInputMaxLengthCheck} />
                </Form.Item>

                <Form.Item
                    label="Alıcı E-postaları"
                    name="emailAddresses"
                    rules={[
                      {
                        validator: (rule, values) => {
                          if (!values) {
                            return Promise.resolve();
                          }

                          const emailRegex =
                            /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
                          const invalidInputs = values.filter(
                            (value) => !value.match(emailRegex)
                          );
                          if (invalidInputs.length === 0) {
                            return Promise.resolve();
                          }

                          if (invalidInputs.length === 1) {
                            return Promise.reject(
                              new Error(
                                `'${invalidInputs.join(
                                  ""
                                )}' geçersiz bir e-postadır.`
                              )
                            );
                          } else {
                            return Promise.reject(
                              new Error(
                                `'${invalidInputs.join(
                                  ", "
                                )}' değerleri geçersiz e-postadır.`
                              )
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      showSearch
                      tokenSeparators={[",", ";"]}
                      mode="tags"
                      placeholder={
                        "Talimat girilen mail adreslerine gönderilir."
                      }
                    ></Select>
                  </Form.Item>
              </>
              : connectionType === "webService" ?
                  <>
                    <Form.Item
                      label={
                         "Kullanıcı Adı"
                      }
                      name="userName"
                      rules={[{ required: true, whitespace: true, message: "'Kullanıcı Adı' alanı gerekli." }]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label="Şifre"
                      name="password"
                      rules={[{ required: true, whitespace: true, message: "'Şifre' alanı gerekli." }]}
                    >
                      <Input.Password autoComplete="new-password" />
                    </Form.Item>

                    {
                      activeBankId === 15 ?  <>
                        <Form.Item
                          label={
                            "Müşteri Numarası"
                          }
                          name="customerNumber"
                          rules={[{ required: true, whitespace: true }]}
                        >
                          <Input maxLength="125" onInput={onInputMaxLengthCheck} />
                        </Form.Item>


                        <Form.Item
                          label={
                            "Kurumsal Kod"
                          }
                          name="corporateCode"
                          rules={[{ required: true, whitespace: true, message: "'Kurumsal Kod' alanı gerekli." }]}
                        >
                          <Input />
                        </Form.Item></> : activeBankId === 210 ? <> </> : <>

                        <Form.Item
                          label={
                            "Client Id"
                          }
                          name="clientId"
                          rules={[{ required: true, whitespace: true, message: "'Client Id' alanı gerekli." }]}
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item
                          label={
                            "Client Secret"
                          }
                          name="clientSecret"
                          rules={[{ required: true, whitespace: true, message: "'Client Secret' alanı gerekli." }]}
                        >
                          <Input />
                        </Form.Item>

                        {
                          activeBankId === 64 ? <>

                            <Form.Item
                              label={
                                "Sertifika"
                              }
                              name="clientCertificate"
                              rules={[{ required: true, whitespace: true, message: "'Sertifika' alanı gerekli." }]}
                            >
                              <TextArea rows={10} />
                            </Form.Item>

                          </> : <></>
                        }
                      </>

                    }

                  </>
                  : <></>
            }




          <Col style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              loading={loading}
            >
              Ekle
            </Button>
          </Col>
        </Col>
      </Row>
    </Form>
  );
};
export default TosBankInfoAddForm;
